import React from 'react'
import { useTranslation } from 'react-i18next'

import DataSourceBenefitsGif from '../../../../assets/dataSources/datasource-benefits.gif'
import "./benefitsDataSources.scss"

function BenefitsDataSources() {

  const { t } = useTranslation()

  return (
    <div>
      <div className="container-benefits-data-sources">
        <h1>{t("datasources.datasource.title")}</h1>
      </div>
      <div className='container-benefits-data-sources-img'>
        <img src={DataSourceBenefitsGif} />
      </div>
    </div>
  )
}

export default BenefitsDataSources